var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("p", [
      _c("span", { staticClass: "strong" }, [
        _vm._v(_vm._s(_vm.widget.label || _vm.widget.id))
      ])
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "hover-shadow box-border-7" },
      [
        !_vm.myTicketList || _vm.myTicketList.length < 1
          ? _c("div", { staticStyle: { color: "#EEE", "font-size": "20px" } }, [
              _vm._v("无符合条件的工单")
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm._l(_vm.myTicketList, function(e) {
          return _c(
            "div",
            { key: e.orderId, staticClass: "ticket-title-line" },
            [
              _c("TicketTitle", {
                staticClass: "ticket-title-line-1",
                attrs: {
                  ticketTitle: e.orderTitle,
                  ticketNo: e.orderId,
                  target: "_blank"
                }
              })
            ],
            1
          )
        })
      ],
      2
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-336f4889", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-336f4889","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ticket/TicketWidgetMyTicketList.vue
// module id = 910
// module chunks = 75